import React, { useState } from 'react'
import { CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CTooltip } from '@coreui/react'
import PEHierarchyComponents from '../../views/dashboard/PEHierarchyComponents'
import { Info } from 'lucide-react'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'

const ProvidereGeneralExamination = ({ generalExaminationData, setGeneralExaminationData, patientDiagnosis, addFilter = false, MasterDiagnosisData, patientDBData, setPatientDBData, noteCallType, patientID, setUpdatePatientDiagnosis, setUpdateOfflineStructure, noteStructureRef }) => {
  const userData = JSON.parse(localStorage.getItem('user'))
  const [visible, setVisible] = useState(false)
  const [extraText, setExtraText] = useState('')
  const [infoText, setInfoText] = useState([])

  const modalContentMap = {
    'Level of Consciousness': [
      'Awake',
      'Lethargic',
      'Stupor (responds to pain)',
      'Obtunded (responds to shout and shaking)',
      'Minimally conscious state: Tracks, follows simple commands, says single words but not complete sentences, positive brainstem reflexes, positive sleep cycles',
      'Vegetative State: Not responding, opens eyes to stimulation, positive sleep cycles, positive brainstem reflexes',
      'Coma: Not responding, variable brainstem reflexes, may see some posturing. PERFORM GCS',
    ],
    'Cognitive Domains': [
      'Attention: Do they pay attention to when you speak to them?',
      'Working Memory: Can they count backward from 100?',
      'Language: Pay attention to speech sound, articulation, grammar, word finding issues...',
      'Memory: Ask them if they can recall a recent event...',
      'Visual Spatial: Can they recognize familiar faces, objects...',
      'Praxis: Problems using a spoon or tools?',
      'Executive: Can patient plan a night out, follow a recipe...',
      'Frontal: CANT TEST THIS ON EXAM. But cues to look for: Do they make inappropriate comments in public?...',
    ],
    'Cranial Nerves': [
      'CN II: Smell',
      'CN III, IV, VI: Move your eyes constrict pupils',
      'Cranial nerve V: Muscles that allow you to eat, facial sensation, tongue sensation',
      'Cranial nerve VII: Muscles of your face: Look for facial droop, ptosis, issues with taste',
      'Cranial nerve VIII: Hearing and balance',
      'Cranial nerve V and X: Swallow mechanism taste',
      'Cranial nerve XI: Shrug shoulders, rotates head',
      'Cranial nerve XII: Moves tongue',
    ],
    Motor: [
      '5/5: Normal strength (patient can overcome your applied resistance)',
      '4/5: Slightly weaker strength',
      '3/5: Patient can lift extremities against gravity however you apply resistance I cannot move them',
      '2/5: Patient moves extremities on bed',
      '1/5: Muscle twitching noted when you asked patient to move extremity',
      'Atrophy is muscle shinkage',
    ],
    Sensory: ['Small fiber: Senses pain temperature', 'Large fiber: Senses balance vibration. Tuning fork and test vibration. Proprioception is tested by asking the patient closed eyes and asked if there are toes up or down'],
    Babinski: ['Toes go up when you slide from outside of foot inside this indicates an upper motor neuron lesion.'],
    Clonus: ['Flap the feet and see if you get abnormal beating. If it is sustained it is indicative of an upper motor neuron lesion. If it is nonsustained it could be related to an upper motor neuron lesion or something else'],
  }

  const role = userData?.Role
  return (
    <>
      <div className="">
        <CAccordion alwaysOpen className={`  ${role == 'provider' ? 'accordion-dark' : 'accordion-light'} `}>
          {[...generalExaminationData]
            .filter((item) => !addFilter || patientDiagnosis?.includes(item.name))
            .map((item, index) => (
              <CAccordionItem itemKey={index} key={index} className="mt-2 border rounded-1">
                <CAccordionHeader>
                  <span className="d-flex align-items-center gap-2">
                    {item.name}
                    {modalContentMap[item.name] && (
                      <Info
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          setExtraText(item.name)
                          setInfoText(modalContentMap[item.name])
                          setVisible(true)
                        }}
                        size={16}
                      />
                    )}
                  </span>
                </CAccordionHeader>
                <CAccordionBody className="p-0" style={{ overflow: 'auto' }}>
                  <PEHierarchyComponents
                    viewData={item}
                    onDataUpdate={(updatedItem) => {
                      setGeneralExaminationData((prev) => prev.map((el) => (el.id === updatedItem.id ? updatedItem : el)))
                    }}
                    MasterDiagnosisData={MasterDiagnosisData}
                    patientDBData={patientDBData}
                    patientID={patientID}
                    setPatientDBData={setPatientDBData}
                    noteCallType={noteCallType}
                    setUpdatePatientDiagnosis={setUpdatePatientDiagnosis}
                    setUpdateOfflineStructure={setUpdateOfflineStructure}
                    noteStructureRef={noteStructureRef}
                  />
                </CAccordionBody>
              </CAccordionItem>
            ))}
        </CAccordion>
      </div>
      <CModal visible={visible} size="lg" onClose={() => setVisible(false)} aria-labelledby="LiveDemoExampleLabel">
        <CModalHeader
          style={{ background: '#282828', color: 'white!important', borderBottom: '1px solid #989898' }}
          // style="background-color: rgb(40, 40, 40); border-bottom: 1px solid gray; color: white; display: flex; justify-content: center; position: relative;"
        >
          <CModalTitle style={{ color: 'white' }} id="LiveDemoExampleLabel">
            {extraText}
          </CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            overflowY: 'auto',
            color: 'white',
            backgroundColor: '#282828',
          }}
        >
          <p
            style={{
              whiteSpace: 'pre-line',
            }}
          >
            {infoText.join('\n')}
          </p>
        </CModalBody>
        <CModalFooter
          className="p-4"
          style={{
            backgroundColor: '#282828', // dark gray
          }}
        >
          <CButton color="secondary" onClick={() => setVisible(false)}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ProvidereGeneralExamination
